import {fork} from 'redux-saga/effects'
import {createSaga} from './create'
import {showSaga} from './show'
import {updateSaga} from './update'

export function* personSaga() {
  yield fork(showSaga)
  yield fork(createSaga)
  yield fork(updateSaga)
}
